import React from "react";
import PropTypes from "react-month-picker";

export default class MonthBox extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onClick: PropTypes.func,
  };
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: this.props.value || "N/A",
    };
  }

  static getDerivedStateFromProps(props) {
    return {
      value: props.value || "N/A",
    };
  }
  render() {
    return (
      <div className="box d-flex align-items-center" onClick={this._handleClick}>
        <span>
          <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1670998030/intel/icons/calendar_daterange_kqklb6.svg" />
        </span>
        {/* <span className="calendar-icon"></span> */}
        <label className="ml-1">{this.state.value}</label>
      </div>
    );
  }
  _handleClick = (e) => {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };
}
